import type { FormikConfig, FormikValues } from "formik";
import { Formik } from "formik";
import type { ZodType } from "zod";
import { toFormikValidationSchema } from "zod-formik-adapter";

import { useFormatMessage } from "@skilitics/localization";

import type { FormContext, FormFormatMessages } from "./FormContext";
import { FormProvider } from "./FormProvider";
import type { TestAttribute } from "./shared";

type Props<Values extends FormikValues> = FormikConfig<Values> &
  TestAttribute &
  Omit<FormContext<Values>, "formatMessage"> & {
    formatStrings?: FormFormatMessages<Values>;
    validationSchema?: ZodType<Partial<Values>>;
  };

export const FormikForm = <Values extends FormikValues>(props: Props<Values>) => {
  const { submitOnBlur, formatStrings, explicitLabels, dataTest, validationSchema, ...formikConfig } = props;
  const formatMessage = useFormatMessage(formatStrings ?? {});

  return (
    <FormProvider
      value={{
        submitOnBlur,
        formatMessage: formatStrings ? formatMessage : undefined,
        explicitLabels,
        hasValidationSchema: !!validationSchema,
        dataTest,
      }}
    >
      <Formik
        enableReinitialize
        validateOnBlur
        {...formikConfig}
        validationSchema={validationSchema ? toFormikValidationSchema(validationSchema) : undefined}
      />
    </FormProvider>
  );
};
